(function () {
  // Busca el enlace del menú por su ID exacto o por su link a la
  // página del live — mucho más confiable que buscar solo por texto.
  function findLiveMenuLink(root) {
    root = root || document;

    var byId = root.querySelector('#HeaderDrawer-live');
    if (byId) return byId;

    var links = root.querySelectorAll('a[href*="/pages/live-shopping"]');
    if (links.length) return links[0];

    var allLinks = root.querySelectorAll('a');
    for (var i = 0; i < allLinks.length; i++) {
      var text = (allLinks[i].textContent || '').trim().toLowerCase();
      if (text === 'live') return allLinks[i];
    }

    // Revisa dentro de cualquier shadow root abierto
    var all = root.querySelectorAll('*');
    for (var j = 0; j < all.length; j++) {
      if (all[j].shadowRoot) {
        var found = findLiveMenuLink(all[j].shadowRoot);
        if (found) return found;
      }
    }
    return null;
  }

  function buildIcon() {
    var svgNS = 'http://www.w3.org/2000/svg';
    var svg = document.createElementNS(svgNS, 'svg');
    svg.setAttribute('viewBox', '0 0 240 120');
    svg.setAttribute('class', 'live-menu-badge-icon');
    svg.setAttribute('aria-hidden', 'true');

    var shapes = [
      { tag: 'circle', attrs: { cx: 120, cy: 60, r: 10, fill: 'currentColor' } },
      { tag: 'path', attrs: { d: 'M130,42.68 A20,20 0 0,1 130,77.32' } },
      { tag: 'path', attrs: { d: 'M110,42.68 A20,20 0 0,0 110,77.32' } },
      { tag: 'path', attrs: { d: 'M137.5,29.69 A35,35 0 0,1 137.5,90.31' } },
      { tag: 'path', attrs: { d: 'M102.5,29.69 A35,35 0 0,0 102.5,90.31' } },
      { tag: 'path', attrs: { d: 'M145,16.7 A50,50 0 0,1 145,103.3' } },
      { tag: 'path', attrs: { d: 'M95,16.7 A50,50 0 0,0 95,103.3' } }
    ];

    shapes.forEach(function (shape) {
      var el = document.createElementNS(svgNS, shape.tag);
      Object.keys(shape.attrs).forEach(function (key) {
        el.setAttribute(key, shape.attrs[key]);
      });
      if (shape.tag === 'path') {
        el.setAttribute('stroke', 'currentColor');
        el.setAttribute('stroke-width', '8');
        el.setAttribute('fill', 'none');
        el.setAttribute('stroke-linecap', 'round');
      }
      svg.appendChild(el);
    });

    return svg;
  }

  function init() {
    var link = findLiveMenuLink();
    if (link) {
      attachBadge(link);
      return;
    }

    var done = false;

    function tryFind() {
      if (done) return;
      var found = findLiveMenuLink();
      if (found) {
        done = true;
        clearInterval(pollInterval);
        observer.disconnect();
        document.removeEventListener('mouseover', tryFind);
        document.removeEventListener('click', tryFind);
        document.removeEventListener('touchstart', tryFind);
        attachBadge(found);
      }
    }

    // Revisión constante cada medio segundo, sin límite de tiempo —
    // así no importa cuándo ni cómo termine de cargar esa parte del
    // menú, tarde o temprano lo va a encontrar.
    var pollInterval = setInterval(tryFind, 500);

    // Observador de cambios en la página (más rápido que el poll)
    var observer = new MutationObserver(tryFind);
    observer.observe(document.body, { childList: true, subtree: true });

    // Revisión también al tocar/pasar el mouse por el menú
    document.addEventListener('mouseover', tryFind, { passive: true });
    document.addEventListener('click', tryFind, { passive: true });
    document.addEventListener('touchstart', tryFind, { passive: true });
  }

  function attachBadge(link) {
    var icon = buildIcon();
    link.appendChild(icon);
    link.classList.add('live-menu-badge-wrapper');

    if (!window.firebase || !window.firebaseConfig) return;
    if (!firebase.apps.length) firebase.initializeApp(window.firebaseConfig);
    var db = firebase.database();

    db.ref('liveShopping/isLive').on('value', function (snapshot) {
      icon.classList.toggle('is-live', snapshot.val() === true);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
